import * as React from 'react';

import { DatePicker, DatePickerProps, TextFieldProps } from '@emburse/ui-core';

import * as style from './DatePickerEmbark.styl';

// @ts-ignore
interface IDatePickerEmbarkProps extends Omit<DatePickerProps<Date>, 'onChange'> {
  value?: any;
  onChange: (date: Date | null, keyboardInputValue?: string) => void;
  id?: string;
  renderInputParams?: TextFieldProps;
  showClearDate?: boolean;
  ignoreInitialError?: boolean;
  error?: boolean;
}

// wrapper for our embark date picker while we wait for full implementation of features
export const DatePickerEmbark: React.FC<IDatePickerEmbarkProps> = (props) => {
  const { renderInputParams, label, showClearDate, value, onChange, ignoreInitialError, error } = props;

  const onValueChange = (date: Date | null, keyboardInputValue?: string) => {
    if (isFirstLoad) {
      setIsFirstLoad(false);
    }
    return onChange(date, keyboardInputValue);
  };

  const [errorMsg, setErrorMsg] = React.useState<string | null | undefined>(null);
  const [isFirstLoad, setIsFirstLoad] = React.useState(true);
  const textFieldParams = {
    ...renderInputParams,
    label: renderInputParams?.label || label,
    // text to show a cancel button to reset the date
    // we can't have multiple end adornments because if we set InputProps, it will overwrite the default
    // calendar icon. There isn't a cancel button in the current embark version (5.19.0) - missing support for the action bar
    helperText: showClearDate && value && 'Cancel',
    FormHelperTextProps: {
      onClick: () => onValueChange(null)
    },
    fullWidth: true,
    error: (Boolean(errorMsg) || Boolean(error)) && !(isFirstLoad && ignoreInitialError)
  };

  React.useEffect(() => {
    if (error && isFirstLoad) {
      setIsFirstLoad(false);
    }
  }, [error]);

  return (
    // TODO change the cancel button once embark is on MUI v7
    <DatePicker
      {...props}
      className={style.global}
      value={value || null} // needs to be null instead of undefined
      onChange={onValueChange}
      slotProps={{ textField: textFieldParams }}
      onError={(reason: any, value: any) => {
        setErrorMsg(reason);
      }}
    />
  );
};
